import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./../styles/header.css"; 
import logo_branca from "../assets/images/logo_ficael_branco.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div id="container">
        {/* Logo */}
        <div className="logo">
          <Link to="/" className="logo-link">
            <img src={logo_branca} alt="Logo" />
          </Link>
        </div>

        {/* Ícone do Menu Hamburguer (visível no mobile) */}
        <div className="menu-icon" onClick={toggleMenu}>
          <i className={`fa ${isMenuOpen ? "fa-times" : "fa-bars"}`}></i>
        </div>

        {/* Menu de Navegação */}
        <nav className={`nav ${isMenuOpen ? "active" : ""}`}>
          <ul className="nav-list">
            <li><Link to="/" className="nav-item">Home</Link></li>
            <li><Link to="/about" className="nav-item">Sobre Nós</Link></li>
            <li><Link to="/projects" className="nav-item">Projetos</Link></li>
            <li><Link to="/products" className="nav-item">Produtos</Link></li>
            <li><Link to="/contact" className="nav-item">Contato</Link></li>
          </ul>
        </nav>
      </div>

      {/* Informações de Contato - Fora do container para evitar ser empurrado pelo menu */}
      <div className="contact-info">
        <span className="phone">(11) 3201-2009 </span>
      </div>
    </header>
  );
};

export default Header;
